<template lang="pug">
  .module__main
    .module__title Настройка обменки
    .module-content__container(v-loading="isLoading || isSettingUpdating")
      .settings__container
        .setting__container
          .setting__title Общие
          .setting__block
            .setting-block__title Название обменника
            .setting-val__container {{ name }}
          .setting__block.one-line
            .setting-block__title Онлайн
            el-switch(v-model="online" @change="changeOnlineStatus")
        .setting__container(v-for="(paymentSystemSetting, paymentSystem) in exchangePaymentSystems" :key="`ps-setting-${paymentSystem}`")
          .setting__title {{ paymentSystemSetting.locale }}
          .setting__block.one-line
            .setting-block__title Активно
            el-switch(v-model="$data[paymentSystemSetting.active]")
          .setting__block
            .setting-block__title Минимальная сумма
            .setting-val__container
              el-input(v-model="$data[paymentSystemSetting.min]" type="number")
          .setting__block
            .setting-block__title Максимальная сумма
            .setting-val__container
              el-input(v-model="$data[paymentSystemSetting.max]" type="number")
          el-button(type="primary" size="mini" @click="updateExchangePaymentSystemSettings(paymentSystem)") Обновить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  CHANGE_EXCHANGE_ONLINE_STATUS,
  EDIT_EXCHANGE_PAYMENT_SYSTEM,
  GET_EXCHANGE_SETTINGS
} from "@/store/const/exchange";
import instruments from "../../mixins/instruments";

export default {
  name: 'ExchangeSettings',
  mixins: [
    instruments,
  ],
  data() {
    return {
      name: '',
      active: false,
      minExchangeAmount: 0,
      maxExchangeAmount: 0,
      activeSbp: false,
      minExchangeAmountSbp: 0,
      maxExchangeAmountSbp: 0,
      activeBankAccount: false,
      minExchangeAmountBankAccount: 0,
      maxExchangeAmountBankAccount: 0,
      activeForeignCard: false,
      minExchangeAmountForeignCard: 0,
      maxExchangeAmountForeignCard: 0,
      activeForeignSbp: false,
      minExchangeAmountForeignSbp: 0,
      maxExchangeAmountForeignSbp: 0,
      activeSim: false,
      minExchangeAmountSim: 0,
      maxExchangeAmountSim: 0,
      activeQR: false,
      minExchangeAmountQR: 0,
      maxExchangeAmountQR: 0,
      online: false,
      isSettingUpdating: false,
      exchangePaymentSystems: {
        card: { locale: 'Карты', active: 'active', min: 'minExchangeAmount', max: 'maxExchangeAmount' },
        sim: { locale: 'Сим', active: 'activeSim', min: 'minExchangeAmountSim', max: 'maxExchangeAmountSim' },
        sbp: { locale: 'СБП', active: 'activeSbp', min: 'minExchangeAmountSbp', max: 'maxExchangeAmountSbp' },
        bank_account: { locale: 'Счёт', active: 'activeBankAccount', min: 'minExchangeAmountBankAccount', max: 'maxExchangeAmountBankAccount' },
        foreign_card: { locale: 'Зарубежная карта', active: 'activeForeignCard', min: 'minExchangeAmountForeignCard', max: 'maxExchangeAmountForeignCard' },
        foreign_sbp: { locale: 'СНГ СБП', active: 'activeForeignSbp', min: 'minExchangeAmountForeignSbp', max: 'maxExchangeAmountForeignSbp' },
        qr: { locale: 'QR', active: 'activeQR', min: 'minExchangeAmountQR', max: 'maxExchangeAmountQR' },
      },
    }
  },
  mounted() {
    this.loadAndSetExchangeSettings();
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('exchange', ['exchangeInfo']),
    isLoading() {
      return this.loading(GET_EXCHANGE_SETTINGS) === 'loading';
    },
    isError() {
      return this.loading(GET_EXCHANGE_SETTINGS) === 'error';
    },
    errorMessage() {
      return this.error(GET_EXCHANGE_SETTINGS);
    },
  },
  methods: {
    ...mapActions('exchange', {
      getExchangeSettings: GET_EXCHANGE_SETTINGS,
      editExchangePaymentSystem: EDIT_EXCHANGE_PAYMENT_SYSTEM,
      changeExchangeOnlineStatus: CHANGE_EXCHANGE_ONLINE_STATUS,
    }),
    async loadAndSetExchangeSettings() {
      const request = await this.getExchangeSettings();
      if (!request.success) {
        this.$message.error(`Ошибка загрузки настроек: ${request.message || 'Неизвестная ошибка'}`);
      }
      this.name = this.exchangeInfo.name;
      this.active = !!this.exchangeInfo.active;
      this.minExchangeAmount = this.exchangeInfo.minExchangeAmount;
      this.maxExchangeAmount = this.exchangeInfo.maxExchangeAmount;
      this.activeSbp = !!this.exchangeInfo.activeSbp;
      this.minExchangeAmountSbp = this.exchangeInfo.minExchangeAmountSbp;
      this.maxExchangeAmountSbp = this.exchangeInfo.maxExchangeAmountSbp;
      this.activeBankAccount = !!this.exchangeInfo.activeBankAccount;
      this.minExchangeAmountBankAccount = this.exchangeInfo.minExchangeAmountBankAccount;
      this.maxExchangeAmountBankAccount = this.exchangeInfo.maxExchangeAmountBankAccount;
      this.activeForeignCard = !!this.exchangeInfo.activeForeignCard;
      this.minExchangeAmountForeignCard = this.exchangeInfo.minExchangeAmountForeignCard;
      this.maxExchangeAmountForeignCard = this.exchangeInfo.maxExchangeAmountForeignCard;
      this.activeForeignSbp = !!this.exchangeInfo.activeForeignSbp;
      this.minExchangeAmountForeignSbp = this.exchangeInfo.minExchangeAmountForeignSbp;
      this.maxExchangeAmountForeignSbp = this.exchangeInfo.maxExchangeAmountForeignSbp;
      this.activeSim = !!this.exchangeInfo.activeSim;
      this.minExchangeAmountSim = this.exchangeInfo.minExchangeAmountSim;
      this.maxExchangeAmountSim = this.exchangeInfo.maxExchangeAmountSim;
      this.activeQR = !!this.exchangeInfo.activeQR;
      this.minExchangeAmountQR = this.exchangeInfo.minExchangeAmountQR;
      this.maxExchangeAmountQR = this.exchangeInfo.maxExchangeAmountQR;
      this.online = this.exchangeInfo.online;
    },
    async updateExchangePaymentSystemSettings(paymentSystem) {
      this.$confirm(`Вы уверены, что хотите именить настройки платежной системы?`, 'Подтверждение').then(async () => {
        this.isSettingUpdating = true;
        const data = {
          active: this[this.exchangePaymentSystems[paymentSystem].active],
          min: parseInt('' + this[this.exchangePaymentSystems[paymentSystem].min]),
          max: parseInt('' + this[this.exchangePaymentSystems[paymentSystem].max]),
        }
        const request = await this.editExchangePaymentSystem({ paymentSystem, data });
        if (request.success) {
          this.$message.success('Настройки успешно обновлены');
        } else {
          this.$message.error(`Ошибка обновления настроек: ${request.message || 'Неизвестная ошибка'}`);
        }
        this.isSettingUpdating = false;
      }).catch(() => {
        this.$message.info('Изменение суммы отменено');
        this.loadAndSetExchangeSettings();
      });
    },
    async changeOnlineStatus() {
      this.$confirm(`Вы уверены, что ${this.online ? 'включить' : 'отключить'} обменник?`, 'Подтверждение').then(async () => {
        this.isSettingUpdating = true;
        const request = await this.changeExchangeOnlineStatus({ online: this.online });
        if (request.success) {
          this.$message.success('Настройки успешно обновлены');
        } else {
          this.$message.error(`Ошибка обновления настроек: ${request.message || 'Неизвестная ошибка'}`);
        }
        this.isSettingUpdating = false;
      }).catch(() => {
        this.$message.info(`${this.online ? 'Включение' : 'Отключение'} отменено`);
        this.online = !this.online;
      });
    },
  }
};
</script>
<style scoped>
.settings__container {
    display: flex;
    flex-wrap: wrap;
    overflow-y: scroll;
}

.setting__container {
    width: 240px;
    padding: 10px;
    background-color: white;
    margin: 5px;
    border-radius: 5px;
    box-shadow: 1px 1px 1px #9f9f9f
}

.setting__title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
}

.setting__block {
    margin-bottom: 10px;
}

.setting__block.one-line {
    display: flex;
}

.setting__block.one-line .setting-block__title {
    margin-right: 5px;
}
</style>
